const CDN_URL = 'https://d3juz1fzbt8tvf.cloudfront.net';

const ANDROID_APK_URL = `${CDN_URL}/production/en/android/com.topco.toptoonglobal.global_toptoonplus_app/daycomics/DayComics.apk`;
const IOS_APK_URL = `itms-services://?action=download-manifest&url=${CDN_URL}/production/en/ios/com.toptoonplus.global.ios/daycomics/manifest.plist`;

export const downloadAppUrl = (
  env: string | undefined,
): { android: string; ios: string } => {
  if (!env) return { android: ANDROID_APK_URL, ios: IOS_APK_URL };
  return {
    android: `${CDN_URL}/${env}/en/android/com.topco.toptoonglobal.global_toptoonplus_app/daycomics/DayComics.apk`,
    ios: `itms-services://?action=download-manifest&url=${CDN_URL}/${env}/en/ios/com.toptoonplus.global.ios/daycomics/manifest.plist`,
  };
};
